import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
    name: 'quicklinkNumberHtml',
    standalone: true
})
export class QuicklinkNumberHtmlPipe implements PipeTransform {

    transform(quickLinkSlug: string, args?: any): any {

        const result = quickLinkSlug?.match(/\d+$/);

        if (!result) {
            return quickLinkSlug;
        }

        const index = result.index;

        if (index) {
            return `${quickLinkSlug.substr(0, index)}<em>${quickLinkSlug.substr(index)}</em>`;
        }

        return quickLinkSlug;
    }

}
